import { useQuery } from '@tanstack/react-query';
import { getRequest } from '../services/apiMethods';

const useVendorDetails = () => {
  const { data, error, isLoading ,refetch:refresh } = useQuery({
    queryKey: ["VendorDetail"],
    queryFn: () => getRequest("/profile/details"),
  });

  return {
    data: data?.data, // Vendor details
    error,            // Error object
    isLoading,
    refresh        // Loading state
  };
};

export default useVendorDetails;
